module.exports = __webpack_public_path__ + "static/media/about2.d28276e8.jpg";